const QuickAddToBundle = function() {
    function QuickAddToBundle() {
        this.selector = {
            cta: document.querySelectorAll(".quick-add-to-bundle"),
            quickbox: document.querySelector(".modal-quick-container"),
            quickboxoverlay: document.querySelector(".modal-quick-overlay"),
            close: document.querySelector(".modal-quick-container > .quick-close"),
            render: document.querySelector(".modal-quick-container > .render")
        }
        this.obj = {
            target_handle: null,
            collection_handle: null,
            product_handle: null
        }
        this.load()
    }
    QuickAddToBundle.prototype.load = function() {
        var _ = this;
        if(_.selector.cta.length > 0) {
            _.selector.cta.forEach(btn => {
                btn.addEventListener("click", event => {
                 _.selector.render.innerHTML = "";
                 _.selector.quickbox.classList.add("active");
                 _.selector.quickboxoverlay.classList.add("active");
                 _.rebuildmodal(event.target.closest("button").dataset.handle, event.target.closest("button").dataset.collectionHandle, event.target);
                })
            })
        }
        _.selector.close.addEventListener("click", () => {
           _.selector.quickbox.classList.remove("active");
           _.selector.quickboxoverlay.classList.remove("active");
        })
        _.selector.quickboxoverlay.addEventListener("click", () => {
            _.selector.quickbox.classList.remove("active");
            _.selector.quickboxoverlay.classList.remove("active");
        })   
        document.addEventListener('bundlebox:close', () => {
            _.selector.quickbox.classList.remove("active");
            _.selector.quickboxoverlay.classList.remove("active");  
            let startfrom = 0;
            var letswaitsecs = setInterval(() => {
                    if(startfrom >= 4) {
                        document.dispatchEvent(new CustomEvent('cart:open'));
                        clearInterval(letswaitsecs);
                    } else {
                        startfrom++;
                    }
            }, 200);    
            letswaitsecs;     
        });
    }
    QuickAddToBundle.prototype.rebuildmodal = async function(handle, collection, target) {
            var _ = this;
            await fetch(`/products/${handle}?sections=main-quick-add-to-bundle`)
            .then(res => res.json())
            .then(data => {
                let custom_quick_view = new DOMParser()
                .parseFromString(data[`main-quick-add-to-bundle`], 'text/html')
                .querySelector('#shopify-section-main-quick-add-to-bundle').innerHTML;
                _.selector.render.innerHTML = custom_quick_view;
                if(theme.Slideshow) {
                    const mainSlider = document.querySelector(".main-quick-container .product-slideshow");
                    const mainSliderArgs = {
                        dragThreshold: 25,
                        adaptiveHeight: true,
                        avoidReflow: true,
                        initialIndex: 1,
                        childNav: null,
                        childNavScroller: null,
                        childVertical: false,
                        pageDots: false, // mobile only with CSS
                        wrapAround: true,
                        callbacks: {
                            onChange: event => {
                                _.onSlideChange(event);
                            }
                          }
                      };
                    const quickviewflickity = new theme.Slideshow(mainSlider, mainSliderArgs);
                    const productreview = target.closest(".grid-product").querySelector(".junip-product-summary").innerHTML;
                    const quickproductreview = document.querySelector(".main-quick-container .product-review");
                    quickproductreview.innerHTML = productreview;
                    const variantid = document.querySelector('.main-quick-container [name="id"]');
                    const variantoption1 = document.querySelectorAll('.modal-quick-container .variant-input[data-index="option1"] > input');
                    const variantlabel = document.querySelector('.modal-quick-container span[data-variant-color-label]');
                    const quantityminus = document.querySelector(".modal-quick-container button.js-qty__adjust--minus");
                    const quantityplus = document.querySelector(".modal-quick-container button.js-qty__adjust--plus");
                    const quantityinput = document.querySelector(".modal-quick-container input.js-qty__num");
                    const formaddtocart = document.querySelector(".modal-quick-container form.product-single__form"); 
                    const quickfinalbundle = document.querySelector(".modal-quick-container .quick-view-bundle");             
                    const quickprice = document.querySelector(".modal-quick-container .product__price");  
                    const quickaddtocart = document.querySelector(".modal-quick-container .custom-add-to-cart-button-group");
                    const salespoint = document.querySelector(".modal-quick-container .product-block--sales-point > .sales-points > .sales-point > .icon-and-text");
                    const thresholdtext = document.querySelector(".modal-quick-container .sales-points [data-threshold]");
                    const preorderproperty = document.getElementById("preorder-field-property");
                    const datacarttext = document.querySelector(".modal-quick-container [data-add-to-cart-text]");
                    const addtocartbtn = document.querySelector(".custom-add-to-cart-button-group button.add-to-cart");
                    const productoutofstock = document.querySelector(".modal-quick-container .product-out-of-stock");
                    const collectionproperty = document.getElementById("bundle-field-property");
                    const descreadmore = document.querySelector(".desc-read-less span.toggle");
                    const descreadless = document.querySelector(".desc-read-more span.toggle");
                    collectionproperty.value = collection;
                    quickviewflickity.goToSlide(variantid.selectedIndex);         
                    if(variantoption1.length > 0) {
                        variantoption1.forEach(input => {
                            input.addEventListener("change", event => {
                                variantid.querySelectorAll("option").forEach((option,index) => {                                  
                                    if(option.dataset.title === event.target.value) {
                                        variantid.selectedIndex = index;
                                        quickviewflickity.goToSlide(index);
                                        if(quickprice) {
                                            quickprice.innerHTML = option.dataset.price;
                                        }
                                        if(variantlabel) {
                                            variantlabel.innerHTML = event.target.value;
                                        } 
                                        if(option.dataset.available === "true" && option.dataset.policy === "continue" && option.dataset.quantity > 0) {
                                            productoutofstock.classList.remove("active");
                                            addtocartbtn.classList.remove("disabled");
                                            addtocartbtn.disabled = false;
                                            addtocartbtn.style.removeProperty("display");
                                            quickaddtocart.classList.remove("preorder");  
                                            salespoint.classList.remove("hide");                                          
                                            salespoint.classList.remove("inventory--preorder");
                                            thresholdtext.innerHTML = "In stock, ships in 1-2 business days";
                                            datacarttext.innerHTML = datacarttext.dataset.defaultText;
                                            preorderproperty.removeAttribute("name");
                                        }
                                        if(option.dataset.available === "true" && option.dataset.policy === "continue" && option.dataset.quantity <= 0) {
                                            productoutofstock.classList.remove("active");
                                            addtocartbtn.classList.remove("disabled");
                                            addtocartbtn.disabled = false;
                                            addtocartbtn.style.removeProperty("display");
                                            quickaddtocart.classList.add("preorder");
                                            salespoint.classList.remove("hide");
                                            salespoint.classList.add("inventory--preorder");
                                            thresholdtext.innerHTML = "Out of stock, ships on expected date!";
                                            datacarttext.innerHTML = datacarttext.dataset.preorderText;
                                            preorderproperty.setAttribute("name", "properties[Preorder]");
                                        }
                                        if(option.dataset.available === "false" && option.dataset.policy === "deny" && option.dataset.quantity >= 0) {
                                            quickaddtocart.classList.remove("preorder");
                                            salespoint.classList.add("hide");
                                            addtocartbtn.classList.add("disabled");
                                            addtocartbtn.disabled = true;
                                            addtocartbtn.style.setProperty("display", "none");
                                            thresholdtext.innerHTML = "";
                                            datacarttext.innerHTML = "";
                                            productoutofstock.classList.add("active");
                                            preorderproperty.removeAttribute("name");
                                        }
                                        if(option.dataset.available === "true" && option.dataset.policy === "deny" && option.dataset.quantity > 0) {
                                            productoutofstock.classList.remove("active");
                                            salespoint.classList.remove("hide");
                                            addtocartbtn.classList.remove("disabled");
                                            addtocartbtn.disabled = false;
                                            addtocartbtn.style.removeProperty("display");
                                            quickaddtocart.classList.remove("preorder");
                                            salespoint.classList.remove("inventory--preorder");
                                            thresholdtext.innerHTML = "In stock, ships in 1-2 business days";
                                            datacarttext.innerHTML = datacarttext.dataset.defaultText;   
                                            preorderproperty.removeAttribute("name");                                        
                                        }
                                      if(option.dataset.available === "false" && option.dataset.policy === "deny" && parseInt(option.dataset.quantity) <= 0) {
                                            quickaddtocart.classList.remove("preorder");
                                            salespoint.classList.add("hide");
                                            addtocartbtn.classList.add("disabled");
                                            addtocartbtn.disabled = true;
                                            addtocartbtn.style.setProperty("display", "none");
                                            thresholdtext.innerHTML = "";
                                            datacarttext.innerHTML = "";
                                            productoutofstock.classList.add("active");
                                            preorderproperty && preorderproperty.removeAttribute("name");
                                        }
                                    }
                                })
                            })
                        })
                    }
                    quantityminus.addEventListener("click", () => {
                        if(Number(quantityinput.value) > 1) {
                            quantityinput.value = Number(quantityinput.value) - 1;
                        }
                    });
                    quantityplus.addEventListener("click", () => {
                            quantityinput.value = Number(quantityinput.value) + 1;
                    });
                    formaddtocart.addEventListener("submit", event => {
                        event.preventDefault();
                        _.addtocart(event, collection);
                    })
                    quickfinalbundle.addEventListener("click", () => {            
                        _.finalbundle(collection);
                    })
                    descreadmore.addEventListener("click", event => {
                        event.target.closest(".product-details").querySelector(".desc-read-more").classList.add("active");
                        event.target.closest(".desc-read-less").classList.remove("active");
                    })
                    descreadless.addEventListener("click", event => {
                        event.target.closest(".product-details").querySelector(".desc-read-less").classList.add("active");
                        event.target.closest(".desc-read-more").classList.remove("active");
                    })
                    _.obj.target_handle = target;
                    _.obj.product_handle = handle;
                    _.obj.collection_handle = collection;
                    _.bundlecart(collection);
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    QuickAddToBundle.prototype.addtocart = async function(event, collection) {
        var _ = this;
        var data = theme.utils.serialize(event.target);
        const addtocartbtn = document.querySelector("button.add-to-cart");
        const addedbundle = document.querySelector(".quick-top-bar > .added-bundle"); 
        const scrolltopel = document.querySelector(".modal-quick-container");
        addtocartbtn.classList.add('btn--loading');
        addedbundle.classList.add('active');
        await fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
          .then(response => response.json())
          .then(function(data) {
            if (data.status === 422) {
                addtocartbtn.classList.remove('btn--loading');
                scrolltopel.scrollTop = 0;

            } else {
              var product = data;
              addtocartbtn.classList.remove('btn--loading');
                _.bundlecart(collection);
                scrolltopel.scrollTop = 0;
            }
          });
    }
    QuickAddToBundle.prototype.bundlecart = async function(collection) {
        var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
        await fetch(url, {
          credentials: 'same-origin',
          method: 'GET'
        })
        .then(response => response.json())
        .then(cart => {
            let bundleitemscount = 0;
            const bundlecountel = document.querySelector(".quick-top-bar > .bundle-count");
            const viewbundleitems = document.querySelector(".quick-top-bar > .quick-view-bundle");
            if(cart.item_count > 0) {
                document.dispatchEvent(new CustomEvent('cart:build'));
                cart.items.forEach(item => {
                    if(item.properties) {
                        if(item.properties["_Bundle"] === collection) {
                            bundleitemscount = bundleitemscount + item.quantity;
                        }
                    }
                })
            } else {
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
            if(bundleitemscount > 0) {
               bundlecountel.innerHTML = `There are ${bundleitemscount} items in your bundle.`;
               viewbundleitems.classList.add("active");
            } else {
               bundlecountel.innerHTML = `There are no items in your bundle.`;
               viewbundleitems.classList.remove("active");
            }
        });
    }
    QuickAddToBundle.prototype.finalbundle = async function(collection) {
        var _ = this;
        await fetch(`/collections/${collection}/?sections=quick-bundle-items`)
        .then(res => res.json())
        .then(data => {
            _.selector.render.innerHTML = "";
            let custom_quick_view = new DOMParser()
            .parseFromString(data[`quick-bundle-items`], 'text/html')
            .querySelector("#shopify-section-quick-bundle-items").innerHTML;
            _.selector.render.innerHTML = custom_quick_view;
            const finalbutton = document.querySelector(".quick-bundle-footer button.quick-final");
            const finalremoveitem = document.querySelectorAll(".quick-remove > button");
            const quickreturn = document.querySelector(".quick-bundle-footer > .quick-return");
            finalbutton.addEventListener("click", () => {  
                document.dispatchEvent(new CustomEvent('cart:build'));              
                document.dispatchEvent(new CustomEvent('bundlebox:close'));
            })
            finalremoveitem.forEach(item => {
                item.addEventListener("click", async event => {
                    const formData = {
                        updates: {
                            [event.target.closest("button").dataset.key]: 0
                        }
                    };  
                    await fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data.items.length > 0) {
                            _.finalbundle(collection);
                        } else {
                            document.dispatchEvent(new CustomEvent('cart:build'));
                            document.dispatchEvent(new CustomEvent('bundlebox:close'));
                        }                        
                    });
                })
            })
            quickreturn.addEventListener("click", event => {
                _.selector.render.innerHTML = "";
                _.rebuildmodal(_.obj.product_handle, _.obj.collection_handle, _.obj.target_handle);
            })
        });
    }
    QuickAddToBundle.prototype.onSlideChange = function(event) {
        const variantoption1 = document.querySelectorAll('.modal-quick-container .variant-input[data-index="option1"] > input');
        variantoption1[event].click();
    }
    QuickAddToBundle = new QuickAddToBundle;
}

QuickAddToBundle();